import ZeroBill2024 from './ZeroBill2024';
export default ZeroBill2024;
